import url from './url';

async function handleNewsletter(payload) {

    return await fetch(`${url}/newsletter`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

export { handleNewsletter }